export default "__VITE_ASSET__Cp3goR4T__"